// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3oq85","header":"PatientQuestionnaire_header__o2pvG","info":"PatientQuestionnaire_info__20vQ2"};